/* eslint prefer-destructuring: 0, no-unused-expressions: 0, no-shadow: 0, react/jsx-props-no-spreading: 0, no-extend-native: 0 */
import React, { Component} from 'react';
import { Route, withRouter, Redirect, Switch } from 'react-router-dom';
import 'react-app-polyfill/ie11';
import './App.scss';
import 'core-js/features/array/find';

//import ReactGA from 'react-ga';

import Home from './routes/Home';
import Congress from './routes/Congress';
import Organization from './routes/Organization';
import { CATEGORIES_FEATURED } from './TEST_RESULTS';

import { fireTag } from './libs/analytics';

import {
	formatMapboxId,
	getCommunityId,
	getMapboxIdFromOrgDash,
	getMapboxKey,
	IDS_TO_COMMUNITIES,
	ORGS_TO_MAP_IDS,
	RESULTS_PER_PAGE,
	US_DISTRICTS,
	US_STATES_BOUNDS,
	DEFAULT_BOUNDS,
	WF_OWNED_SITES,
	EXIT_OVERLAY_EXCEPTIONS,
} from './constants';
import { GAfireEvent } from './components/Tracking';
import Housing from "./routes/Housing";
import Sustainability from "./routes/Sustainability";
import 'wicg-inert';
import Mayors from "./routes/Articles/Mayors";
import Goals from "./routes/Articles/Goals";
import EV from "./routes/Articles/EV";
import Solar from "./routes/Articles/Solar";
import UrbanForests from "./routes/Articles/UrbanForests";
import Bonds from "./routes/Articles/Bonds";
import Trends from "./routes/Articles/Trends";
import Shift from "./routes/Articles/Shift";
import Engaging from "./routes/Articles/Engaging";
import Pipeline from "./routes/Articles/Pipeline";
import Propel from "./routes/Articles/Propel";
import Transformative from './routes/Articles/Transformative';
import PastFuture from './routes/Articles/PastFuture';
import EVInvestment from './routes/Articles/EVInvestment';
import BrightenCity from './routes/Articles/BrightenCity';
import NuclearEnergy from './routes/Articles/NuclearEnergy';
import SustainabilityTrends from './routes/Articles/SustainabilityTrends';



/*

ReactGA.initialize('UA-39500825-5', {
	titleCase: false,
});
*/

if (!String.prototype.replaceAll) {
	// eslint-disable-next-line func-names
	String.prototype.replaceAll = function (str, newStr) {

		// If a regex pattern
		if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
			return this.replace(str, newStr);
		}

		// If a string
		return this.replace(new RegExp(str, 'g'), newStr);

	};
}

let stateRun = 0;
const numOfCategories = Object.keys(IDS_TO_COMMUNITIES).length;

const mapIds = [];
Object.keys(IDS_TO_COMMUNITIES).forEach(key => {
	mapIds.push(ORGS_TO_MAP_IDS[getMapboxKey(key)]);
});

const blankResultsList = {};
Object.keys(IDS_TO_COMMUNITIES).forEach(key => {
	blankResultsList[IDS_TO_COMMUNITIES[key]] = [];
});

const getNearbyOrgs = async (requestObj) => {
	const coordinates = requestObj.coordinates;
	const locationType = requestObj.place_type;

	// replace the query URL text with what we found
	// replace "san diego, ca" with "San Diego, California"
	const uCasedText = Object.prototype.hasOwnProperty.call(requestObj, 'place_name') ? requestObj.place_name : requestObj.text;

	const tilequeryResponse = coordinates.length
		? await fetch(
			`${process.env.PUBLIC_URL}/api/tileset.php?long=${coordinates[0]}&lat=${coordinates[1]}`,
		)
			.then(response => (response.ok ? response.json() : Promise.reject(new Error('tilequery data was not received'))))
			.catch(err => console.error(err))
		: [];

	const { features } = tilequeryResponse;

	// exit here if no features
	if (!features || features.length < 1) return false;

	// bound for USA
	const bounds = {
		minLat: DEFAULT_BOUNDS.minLat,
		maxLat: DEFAULT_BOUNDS.maxLat,
		minLong: DEFAULT_BOUNDS.minLong,
		maxLong: DEFAULT_BOUNDS.maxLong,
	};

	features.forEach(result => {
		const long = result.geometry.coordinates[0];
		const lat = result.geometry.coordinates[1];

		if (lat > bounds.minLat) {
			bounds.minLat = lat;
		}
		if (lat < bounds.maxLat) {
			bounds.maxLat = lat;
		}

		if (long < bounds.minLong) {
			bounds.minLong = long;
		}
		if (long > bounds.maxLong) {
			bounds.maxLong = long;
		}
	});

	return {
		list: features,
		total: features.length,
		meta: true,
		coordinates,
		bounds: {
			minLat: bounds.minLat,
			minLong: bounds.minLong,
			maxLat: bounds.maxLat,
			maxLong: bounds.maxLong,
		},
		specs: {
			text: uCasedText,
			type: locationType,
			abrvState: '',
			keywords: '',
		},
	};
};

///////////////////////////////////////////////////////////////////////
// User Entered Text Search funcionality
///////////////////////////////////////////////////////////////////////
const getOrgsByText = (searchResults, inputObj, toSort) => {

	// bound for USA
	const bounds = {
		minLat: DEFAULT_BOUNDS.minLat,
		maxLat: DEFAULT_BOUNDS.maxLat,
		minLong: DEFAULT_BOUNDS.minLong,
		maxLong: DEFAULT_BOUNDS.maxLong,
	};

	let total = 0;
	let stateAbbrev = false, stateName = '', cityOrOrg = '';
	let congressResults = [];

	if (inputObj.place_type !== 'organization') {
		// only parse a text search if the place_type was NOT organization -
		// if place_type was 'organization' then it means a user selected a specific
		// org from suggestions, so no need to parse it for city or state filtering.

		// text is the string from the input field
		// parse that using spaces into an array
		let textArray = (typeof inputObj.text !== 'undefined' && inputObj.text !== '') ? inputObj.text.split(' ') : [];

		if (textArray.length) {
			// trim and lowercase each array element
			textArray = textArray.map(i => i.trim().toLowerCase());

			textArray.forEach((term, index, object) => {
				if (['hampshire', 'jersey', 'york', 'mexico', 'carolina', 'dakota', 'island', 'virginia', 'rico'].indexOf(term) > -1) {
					// fix parsed terms for 2-word U.S. States
					// Hampshire, Jersey, York, Mexico, Carolina, Dakota, Island, Virginia, Rico
					// if these terms are found, get preceding term and concatenate
					// then remove that preceding element
					object[index] = `${textArray[index - 1]} ${term}`;
					object.splice((index - 1), 1);
				}
			});

			// check to see if any array element contains a valid US state.
			// elements in array that are NOT a US state, are then either a city or part of org name
			textArray.forEach(term => {
				const stateFound = US_STATES_BOUNDS.find(usState => (usState.abrv.toLowerCase() === term || usState.state.toLowerCase() === term));
				stateFound ? (stateAbbrev = stateFound.abrv, stateName = stateFound.state) : cityOrOrg += ` ${term}`;

			});

			// if cityOrOrg is not empty, trim any leading/trailing spaces
			cityOrOrg = cityOrOrg.length && cityOrOrg.trim();

		}
	}
	else {
		// was an org place_type, so just set all search terms into that var
		cityOrOrg = inputObj.text.trim();
	}

	Object.keys(searchResults).forEach(category => {
		searchResults[category].forEach(result => {

			let textExp;
			let foundMatch;

			if (stateAbbrev) { // text criteria contains a state abbrev
				textExp = new RegExp(stateAbbrev, 'i');
				foundMatch = textExp.test(result.properties.state); // now check for U.S. STATE,
				if (foundMatch && cityOrOrg.length) { // if U.S. STATE matched AND have another text term, use that to check it against CITY
					foundMatch = false; // reset our flag to false;
					textExp = new RegExp(cityOrOrg, 'i');
					foundMatch = textExp.test(result.properties.city); // check other passed in term against CITY
					if (!foundMatch) { // this result's CITY did NOT find a match, but use that same input term to check against ORG NAME
						foundMatch = textExp.test(result.properties.name);
					}
				}
			}
			else if (cityOrOrg) { // since no match on U.S. STATE, use that to check agsinst ORG NAME
				textExp = new RegExp(cityOrOrg, 'i');
				foundMatch = textExp.test(result.properties.name);
			}
			else {
				// input was blank, so no criteria, hence all results match.
				foundMatch = true;
			}

			if (foundMatch) {
				const long = result.geometry.coordinates[0];
				const lat = result.geometry.coordinates[1];

				if (lat > bounds.minLat) {
					bounds.minLat = lat;
				}
				if (lat < bounds.maxLat) {
					bounds.maxLat = lat;
				}

				if (long < bounds.minLong) {
					bounds.minLong = long;
				}
				if (long > bounds.maxLong) {
					bounds.maxLong = long;
				}

				const categoryName = IDS_TO_COMMUNITIES[result.properties.category_id];

				total++;

				// CD experience uses org results as one long array
				congressResults = congressResults.concat(result);

			} // end match check
		});

		if (toSort) {
			// sort each category by organization name
			this.resultsList[category].sort((a, b) => {
				if (a.properties.name.trim() < b.properties.name.trim()) return -1;
				if (a.properties.name.trim() > b.properties.name.trim()) return 1;
				return 0;
			});
		}
	}); // end key loop

	let specsType;

	stateAbbrev && !cityOrOrg.length // state only
		? specsType = 'region'
		: congressResults.length === 0
			? specsType = inputObj.place_type
			: specsType = 'keyword';

	return {
		list: congressResults,
		total,
		meta: true,
		bounds: {
			minLat: bounds.minLat,
			minLong: bounds.minLong,
			maxLat: bounds.maxLat,
			maxLong: bounds.maxLong,
		},
		// if just a state abbrev or state in search input, then its a region, otherwise its a keyword type of search
		specs: {
			text: stateAbbrev ? stateName : inputObj.text,
			type: specsType, // (stateAbbrev && !cityOrOrg.length) ? 'region' : 'keyword',
			abrvState: stateAbbrev || '',
			keywords: cityOrOrg.length ? cityOrOrg : '',
		},
	};
};

const removeUndefFromArray = (arr) => arr.filter(e => typeof e != 'undefined');

const resetResults = async () => {
	const searchResultsByCategory = {};
	let searchResultsAll = [];
	let total = 0;

	await Promise.all(
		Object.keys(IDS_TO_COMMUNITIES).map((key) => fetch(`${process.env.PUBLIC_URL}/api/?category_id=${key}`)
			.then(
				response => (response.ok ? response.json() : Promise.reject(new Error('data was not received')))
			)
			.then(async categoryOrgs => {
				const { features } = categoryOrgs;
				const cleanFeatures = removeUndefFromArray(features);
				const cleanLen = cleanFeatures.length;
				searchResultsByCategory[IDS_TO_COMMUNITIES[key]] = await removeUndefFromArray(features);
				total += cleanLen;
			})),
	).then(() => {
		for (let i = 0; i < numOfCategories; i++) {
			searchResultsAll = searchResultsAll.concat(searchResultsByCategory[IDS_TO_COMMUNITIES[i]]);
		}
	});

	const results = {
		list: searchResultsByCategory,
		all: searchResultsAll,
		total,
		coordinates: '',
		bounds: '',
		specs: {},
	};
	return Promise.resolve(results);
};

const locationHistory = [];
let firstUpdate;

class App extends Component {
	closeNavTimer = () => {
		setTimeout(() => {

			this.setState({
				closeNav: true,
			});

		}, 1000);
	};

	handleInputChange = async event => {
		// console.log('handleInputChange');

		// moves focus onto the search icon (so the soft keyboard closes on mobile devices)
		this.checkMobile() && document.getElementById('search-btn').focus();

		this.ResultsBacktoTop();

		const newSearch = this.state.search.results || {};
		const inputObj = event.value || {};
		// const input = inputObj.text || '';

		newSearch.search = inputObj.text;
		newSearch.categoryKey = null;
		newSearch.category = null;

		if (inputObj.text === '') {
			if (this.state.results.currentSearch) {
				newSearch.queryString = `?search=${this.state.results.currentSearch}`;
			}
			else {
				newSearch.queryString = '';
			}
		}
		else {
			newSearch.queryString = `?search=${inputObj.text}`;
		}


		this.setState((prevState) => ({
			[event.name]: {
				...prevState[event.name],
				[event.action]: inputObj,
			},
			search: {
				results: newSearch,
			},
			results: {
				...prevState.results,
				input: inputObj,
			},
			home: {
				...prevState.home,
				input: inputObj,
			},
		}));
	};

	updateQueryStringParameter = (uri, key, value) => {
		let newQS = '';

		const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
		const checkAmpNeededStart = new RegExp(`([?])${key}=.*?(&|$)`, 'i');
		const checkRe = uri.match(re);
		const checkAmpStart = uri.match(checkAmpNeededStart);

		const isMiddle = (checkRe && (checkRe[1] === checkRe[2]));
		const isStart = (checkAmpStart && (checkAmpStart[1] === '?' && checkAmpStart[2] === '&'));

		let operation;

		if (value === '') {
			operation = 'removeQuery';
		}
		else if (uri.match(re)) {
			operation = 'updateQuery';
		}
		else {
			operation = 'addQuery';
		}


		let separator;

		if (uri !== '') {
			if (uri.indexOf('?') !== -1) {
				separator = '&';
			}
			else {
				separator = '?';
			}
		}
		else {
			separator = '?';
		} // ?


		switch (operation) {
			case 'removeQuery':

				if (isMiddle) {
					newQS = uri.replace(re, '&');
				}
				else if (isStart) {
					newQS = uri.replace(re, '');
				}
				else {
					newQS = uri.replace(re, '');
				}
				break;
			case 'updateQuery':
				if (isStart) {
					newQS = uri.replace(re, `$1${key}=${value}$2&`);
				}
				if (isMiddle) {
					newQS = uri.replace(re, `$1${key}=${value}$2`);
				}
				else {
					newQS = uri.replace(re, `$1${key}=${value}$2`);
				}
				break;
			case 'addQuery':
				newQS = `${uri + separator + key}=${value}`;
				break;
			default:
				break;
		}

		// make sure the querystring ALWAYS has a ? as the first character - in case it was removed
		newQS = newQS !== '' && newQS.charAt(0) !== '?' ? `?${newQS}` : newQS;

		return newQS;
	};

	constructor(props) {
		super(props);

		this.dropDownCongress = React.createRef();

		this.state = {
			loadingFilter: true,
			closeNav: true,
			appData: {
				featuredOrgs: [],
			},
			home: {
				input: {},
				showFilter: false,
			},
			sustainability: {
				input: {},
				showFilter: false,
			},
			organizations: {
				showFilter: false,
			},
			results: {
				input: {},
				isLoading: false,
				requestType: 'search',
				currentRequest: '',
				resultsPos: 0,
				featuredOrgs: null,
				showFilter: false,
				showOnlySelectedLayer: false,
				showListView: false,
				hideListViewDesktop: true,
				searchResultsByCategory: {},
				totalResults: 0,
				totalResultsByCategory: {},
				reZoom: true,
				initialFeaturesLoaded: false,
				filterType: null,
				invalidZip: false,
				activeCategoryID: '',
				clearAutocomplete: false,
			},
			featured: {
				showFilter: false,
			},
			isMobile: false,
			hoveredId: null,
			hoveredLayer: null,
			search: {
				results: {
					search: null,
					categoryKey: null,
					queryString: null,
					category: null,
				},
				organizations: {
					queryString: null,
				},
				featured: {
					categoryKey: null,
					queryString: null,
					category: null,
				},
				districts: {
					categoryKey: null,
					queryString: null,
					category: null,
				},
			},
			congress: {
				filter: '',
				selected: {
					stateName: 'State',
					districtName: 'District',
					abrvState: 'US',
					district: 'US',
					category: '',
					categoryName: '',
					categoryId: '',
				},
				organizations: {
					all: [],
					byDistrict: [],
					byState: [],
				},
				orgs: [],
				mapbox: {
					zoom: window.innerWidth < 768 ? 2.2 : 3.5, // DEFAULT MAP ZOOM level for district experience on page load
					rotation: -10,
					center: window.innerWidth < 768 ? [-98, 32] : [-105, 39], // DEFAULT MAP CENTER for district experience on page load
				},
				navOptions: [
					{
						name: 'Filter By Type',
						page: 'type',
					},
					{ name: 'Filter By District', page: 'district' }, { name: 'List View', page: 'list' },
				],
				currentNav: 'default',
				filterDistrict: {
					state: false,
					congressDistrict: false,

				},
				state: false,
				type: false,
				districts: [],
				searchType: '',
			},
			lastFocus: null,

		};

		this.featuredOrg;

	}

	handleClickOutside = event => {

		// function to handle clicking outside the Category (mobile only), U.S. state (desktop and mobile), and
		// district filter (desktop and mobile) button and dropdowns to close them if
		// clicked outside of them when they are open

		const isDropdownOpen = this.state.congress.filterDistrict.state || this.state.congress.filterDistrict.congressDistrict || this.state.results.showFilter;

		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
		const isEdge = !!/Edge/.test(navigator.userAgent);

		let notAButton = false;

		if (event.target.className !== 'list-group-item'
			&& event.target.className !== 'community'
			&& event.target.className !== 'list-dropdown open'
		) {
			if (!isIE11 && !isEdge) { // MS IE 11 does not support event.path but MS IE 11 did need it
				const elementPath = event.path || (event.composedPath && event.composedPath());
				const elementPathClassNames = elementPath.map((e) => e.className);

				if (elementPathClassNames.indexOf('filter-btn') === -1
					&& elementPathClassNames.indexOf('filter-btn has-district-zoom') === -1
					&& elementPathClassNames.indexOf('toggle type open') === -1
				) {
					notAButton = true;
				}
			}
			else {
				// was IE 11.x
				notAButton = true;
			}
		}

		if (isDropdownOpen && notAButton === true) {
			// only close a dropdown if they are OPEN and the user has not clicked on the any filter button or dropdown items
			// so in essence, when clicking on anything else other than the dropdown filters if they are open
			this.setState((prevState) => ({
				results: {
					...prevState.results,
					showFilter: false,
				},
				congress: {
					...prevState.congress,
					filterDistrict: {
						...prevState.congress.filterDistrict,
						state: false,
						congressDistrict: false,
					},
				},
			}));
		}
	};

	///////////////////////////////////////////////////////
	// Add click event listeners for any EXTERNAL
	// NON-WF-owned link only. Doing this avoids changing any
	// component code to accommodate anchor tags in all
	// the featured article body content as well as anywhere
	// else throughout the site.
	///////////////////////////////////////////////////////
	addExitClickListeners = () => {
		// get all anchor tags with target="blank" or target="_blank"
		let anchorLinks = document.querySelectorAll('a[target="_blank"], a[target="blank"]');

		// don't count the external link used for the Continue link - so we remove it from our list
		anchorLinks = Array.from(anchorLinks).filter(link => link.id !== 'modal-continue' && link.id !== 'hamburger');

		anchorLinks.forEach(anchorLink => {

			// using each external link from the DOM, check that against the array of WF
			// owned sites and if we DON'T find that link inside the WF_OWNED_SITES array,
			// then we add the click event listener to show the exitOverlay
			if (anchorLink.dataset.clickListener !== 'true' && !WF_OWNED_SITES.find(wfURL => anchorLink.href.indexOf(wfURL) > -1) || anchorLink.dataset.clickListener !== 'true' && EXIT_OVERLAY_EXCEPTIONS.find(wfURL => anchorLink.href.indexOf(wfURL) > -1)) {

				anchorLink.setAttribute('data-click-listener', 'true');
				anchorLink.addEventListener('click', this.displayModalOverlay);
			}else if (anchorLink.dataset.clickListener === 'true'){
				anchorLink.addEventListener('click', this.displayModalOverlay);

			}
		});
	};


	addVideoClickListeners = () => {

		// get all anchor tags with target="blank" or target="_blank"
		let anchorLinks = document.querySelectorAll('a[data-videoid]');

		// don't count the external link used for the Continue link - so we remove it from our list
		anchorLinks = Array.from(anchorLinks).filter(link => link.id !== 'modal-continue' && link.id !== 'hamburger');

		anchorLinks.forEach(anchorLink => {
			// console.log(anchorLink);
			// using each external link from the DOM, check that against the array of WF
			// owned sites and if we DON'T find that link inside the WF_OWNED_SITES array,
			// then we add the click event listener to show the exitOverlay

			anchorLink.setAttribute('data-click-listener', 'true');
			anchorLink.addEventListener('click', this.displayVideoOverlay);
		});
	};

	///////////////////////////////////////////////////////
	// Show video overlay function
	// called from click event listener
	///////////////////////////////////////////////////////
	displayVideoOverlay = event => {
		// console.log(event.currentTarget.dataset.videoType);
		event.preventDefault();
		this.lastFocus = event.currentTarget;
		this.setState({
			modalOverlay: {
				open: true,
				videoType: event.currentTarget.dataset.videoType,
				continueLink: false,
				videoID: event.currentTarget.dataset.videoid,
				videoPath: event.currentTarget.dataset.videopath || false,
				captionPath: event.currentTarget.dataset.captionpath || false,
			},
		});
	};


	///////////////////////////////////////////////////////
	// Show exit overlay function
	// called from click event listener
	///////////////////////////////////////////////////////
	displayModalOverlay = (event, href) => {
		event.preventDefault();
		this.lastFocus = event.currentTarget;
		this.setState({
			modalOverlay: {
				open: true,
				continueLink: event.currentTarget.href || href || false,
				videoID: event.currentTarget.dataset.videoId || false,
				transcript: event.currentTarget.getAttribute('data-transcript') || false
			},
		});
	};

	///////////////////////////////////////////////////////
	// Close/Cancel exit overlay function
	// called from ExitOverlay component
	///////////////////////////////////////////////////////
	closeExitOverlay = () => {
		this.setState({
			modalOverlay: {
				open: false,
			},
		}, () => {
			this.lastFocus.focus();

			document.getElementsByTagName('html')[0].style.overflow = null;
			document.getElementsByTagName('html')[0].style.margin = null;
			document.getElementsByTagName('html')[0].style.height = null;

			document.body.style.overflow = null;
			document.body.style.margin = null;
			document.body.style.height = null;

			document.body.getElementsByTagName('main')[0].inert = null;
		});
	};

	///////////////////////////////////////////////////////
	// Accessibility Requirement
	// Traps tab key in modal when it is open.
	///////////////////////////////////////////////////////
	trapTabOrderinModal = (modal) => {
		modal.addEventListener('keydown', e => {
			modal.setAttribute('data-keydown-listener', 'true');
			switch (e.which) {
				case 9: { // tab key
					if (e.shiftKey) {
						if (document.activeElement.id === 'modal-x-icon') {
							e.preventDefault();
							document.getElementById('modal-continue').focus();
						}
					}
					else {
						if (document.activeElement.id === 'modal-continue') {
							e.preventDefault();
							document.getElementById('modal-x-icon').focus();
						}
					}
					break;
				}
				case 27: { // ESC key
					this.closeExitOverlay();
					break;
				}
				default:
					break;
			}
		});
	};

	///////////////////////////////////////////////////////
	// Handle linking to/fro footer diclaimers to their
	// references in the body.
	///////////////////////////////////////////////////////
	disclaimerLinking = () => {
		const superscripts = [...document.querySelectorAll('.disc-sup')];
		superscripts.forEach(sup => {
			sup.addEventListener('click', (e) => {
				e.preventDefault();

				const eventTarget = e.currentTarget;
				const targetAnchor = document.getElementById(eventTarget.dataset.goTo);

				if (targetAnchor.getAttribute('tabindex') === '-1') {
					// if tabindex is -1 then must NOT on a visible panel, so make it visible first
					if (window.innerWidth < 1024) {
						document.querySelector(`button.focus-btn.mobile[data-cat-id="${targetAnchor.dataset.catId}"]`).click();
					}
					else {
						document.querySelector(`#desktop-buttons button.focus-btn[data-cat-id="${targetAnchor.dataset.catId}"]`).click();
					}
				}

				window.setTimeout(() => {
					targetAnchor.focus();
				}, 750, this.goToAnchor(e, 200));

			});
		});
	};

	/////////////////////////////////////////////////////////////////////////
	// Main USER ENTERED Search Logic
	/////////////////////////////////////////////////////////////////////////
	handleSearch = params => {

		const { type, name, clear, origin } = params;


		// if origin is not 'results', then search/filter is not from results page and navClose must be toggled.
		const toggleNavClose = () => (origin !== 'results' && origin !== 'congress');

		const isDistrictExp = true;

		const openNavTimer = () => {
			setTimeout(() => {
				this.setState({
					closeNav: false,
				}, () => {
				});
			}, 1000);
		};

		const executeSearch = async () => {
			let requestQuery;
			let showOnlySelectedLayer;
			let requestType;
			let filterType;
			let inputText;
			let currentSearch;
			let isLocationSearch = false;
			let invalidZip = false;
			let data = {
				// eslint-disable-next-line react/no-access-state-in-setstate
				list: this.state.results.searchResultsByCategory,
				coordinates: '',
				bounds: '',
				specs: {
					text: '',
					type: '',
					abrvState: '',
					keywords: '',
				},
			};

			let search;
			// eslint-disable-next-line react/no-access-state-in-setstate
			const CDselections = this.state.congress.selected;
			let { activeCategoryID, clearAutocomplete } = this.state.results;
			const { totalResultsByCategory, input } = this.state.results;
			let inputObj = input || {};
			const shouldClear = clear || false;
			const isOrgDetailPage = origin === 'organization';
			const isHomePage = origin === 'home';
			const isSustainabilityPage = origin === 'sustainability';

			if (type !== 'community') {
				requestQuery = (inputObj && !shouldClear) ? inputObj.text : '';

				if (!shouldClear) {
					if (inputObj.validLocation === true) {
						inputObj.place_type !== 'region' && (
							isLocationSearch = true
						);
					}
					else if (inputObj.type === 'postcode') {
						// Geocoder did not return a valid location, and was a type of post code
						// so zip must be invalid
						invalidZip = true;
						filterType = 'location';
					}
				}
				else {
					// shouldClear is true - so empty the input object and category
					inputObj = {};
					activeCategoryID = '';
				}
			}

			/////////////////////////////////////////////////////////////////////////
			// DEFAULT AND CD  ZIP CODE SEARCH LOGIC
			// which is results by distance from location center based upon criteria
			/////////////////////////////////////////////////////////////////////////
			if (isLocationSearch) {
				data = await getNearbyOrgs(inputObj);
				inputText = requestQuery;
				requestType = 'search';
				currentSearch = inputText;
				filterType = 'location';

				if (!data) {
					// attempted a location search, but it returned no data
					requestQuery = requestQuery.replace(/\s+/g, ' ').trim();
					isLocationSearch = false;
				}

				search = this.state.search.results;
			}
			/////////////////////////////////////////////////////////////////////////
			// DEFAULT AND CD TEXT SEARCH LOGIC
			// which is alphabetical results based upon criteria
			/////////////////////////////////////////////////////////////////////////
			if (!isLocationSearch && type === 'input') {
				let newSearch = {};
				requestType = 'search';

				inputObj.place_type === 'organization'
					? (inputObj.category = '', activeCategoryID = '')
					: inputObj.category = activeCategoryID;

				// replace any double spaces with single spaces, then trim leading and trailing spaces
				requestQuery = requestQuery.replace(/\s+/g, ' ').trim();

				if (requestQuery !== '') {
					let totalResults = totalResultsByCategory;
					if (!totalResults) {
						totalResults = await resetResults().list;
					}

					data = getOrgsByText(totalResults, inputObj, false);

					data.total > 0 && (filterType = data.specs.type);

					newSearch = (!shouldClear) ? (this.state.search.results || {}) : {};
					search = newSearch;

				}
				else {
					// reset data if blank search
					if (totalResultsByCategory) {
						data = {
							list: totalResultsByCategory,
							total: this.state.results.originalTotal,
							specs: {},
						};
					}
					else {
						data = await resetResults();
					}
				}

				newSearch.queryString = this.updateQueryStringParameter(
					newSearch.queryString || '',
					'search',
					requestQuery,
				);

				inputText = requestQuery;
				currentSearch = inputText;

			}
			/////////////////////////////////////////////////////////////////////////
			// DEFAULT CATEGORY FILTERING LOGIC
			// (CD Category filtering done via ChooseDropDownType)
			/////////////////////////////////////////////////////////////////////////
			else if (!isLocationSearch && type === 'community') {
				const category = name.toLowerCase().replace(/\s+/g, '-');
				// const qs = window.location.search;
				//const doesTargetDistrict = qs !== undefined && qs.indexOf('target=district') > -1;
				const doesTargetDistrict = true;
				requestQuery = name;
				requestType = 'category';

				currentSearch = this.state.results.currentSearch;

				inputText = (currentSearch !== '' && !shouldClear) ? this.state.results.input.text : '';
				let newSearch = this.state.search.results || {};

				if (isOrgDetailPage || isHomePage || isSustainabilityPage) {
					// if coming from org detail or home page via category drop down
					// clear out any other search settings
					inputText = '';
					newSearch = {};
					currentSearch = '';
					inputObj = {};

					// remove the search=*** querystring from URL if it has it and was on org detail page
					newSearch.queryString = this.updateQueryStringParameter(
						newSearch.queryString || '',
						'search',
						'',
					);
				}

				newSearch.category = doesTargetDistrict ? formatMapboxId(category) : category;
				newSearch.categoryKey = getCommunityId(name);

				newSearch.queryString = this.updateQueryStringParameter(
					newSearch.queryString || '',
					'category',
					(this.state.results.currentRequest === name && !isOrgDetailPage ? '' : newSearch.category),
					// if prev category matches current, then it was deselected so remove it, and NOT on org detail page.
				);

				if (newSearch.categoryKey === activeCategoryID && !isOrgDetailPage) {
					// category was de-selected
					// current selected categoery MATHCES previously selected category,
					// so newSearch category field should be nothing,
					// and requestQuery is whatever the previous search was (if existed), otherwise its blank.
					newSearch.category = null;
					newSearch.categoryKey = null;
					activeCategoryID = '';
					requestQuery = currentSearch !== '' ? currentSearch : '';
					filterType = '';
					showOnlySelectedLayer = false;

					// if de-selecting a category, there may have been a previous search
					// which is stored in the input object. we can check that for the previous search type.
					const priorSearchType = Object.prototype.hasOwnProperty.call(inputObj, 'place_type') && inputObj.place_type;


					switch (priorSearchType) {
						case 'place':
						case 'postcode':
							filterType = 'location';
							isLocationSearch = true;
							break;
						case 'keyword':
							filterType = 'keyword';
							break;
						case 'region':
							filterType = 'region';
							break;
						default:
							filterType = '';
					}
				}
				else {
					activeCategoryID = newSearch.categoryKey;
					filterType = 'category';
					showOnlySelectedLayer = true;
				}

				// rest left rail results back to top is was scrolled down
				this.ResultsBacktoTop();

				search = newSearch;

			}
			/////////////////////////////////////////////////////////////////
			// SEARCH FILTERING LOGIC CONDITIONALS END HERE
			/////////////////////////////////////////////////////////////////

			document.body.classList.remove('showMapToggle');

			// data returned by searches is formatted differently for default vs CD experiences
			// default searched data is orgs organized into categories
			// CD searched data is all orgs in a single array
			// eslint-disable-next-line react/no-access-state-in-setstate
			let resultsByCategory = isDistrictExp ? this.state.results.searchResultsByCategory : (data ? data.list : blankResultsList);
			//let resultsByCategory = data ? data.list : blankResultsList;


			isOrgDetailPage && filterType === 'category' && (resultsByCategory = totalResultsByCategory);

			let CDfilter = 'search';
			let CDcoordinates = {};

			if (isDistrictExp) {

				if (data.specs.type === 'region') {
					// US State search
					// so need to get and set the district drop down data for that U.S. State
					this.setDistrictUIData({
						abrvState: data.specs.abrvState,
						stateName: data.specs.text,
					});
					CDfilter = 'state';

					const FoundState = US_STATES_BOUNDS.find(usState => usState.state === data.specs.text);
					CDcoordinates = FoundState.coordinates;
					CDselections.district = 'US';
					CDselections.districtName = 'District';
					CDselections.abrvState = data.specs.type === 'region' ? data.specs.abrvState : 'US';
					CDselections.stateName = data.specs.type === 'region' ? data.specs.text : 'State';
				}

				if (isHomePage || isOrgDetailPage || isSustainabilityPage || inputObj.place_type === 'organization') {
					// if there was a search text from home or org detail page or the organization was
					// selected from the suggested list, clear out the category filters
					// regardless if that org or search text is in that same category
					CDselections.category = '';
					CDselections.categoryId = '';
					CDselections.categoryName = '';
				}

				if (inputObj.place_type === 'organization' || data.specs.type === 'postcode' || data.specs.type === 'place') {
					// if an organization was selected from the suggested list, or a location
					// search performed, clear out any state selections, or district selections
					// regardless if they were the same state or district for that org or not
					CDselections.district = 'US';
					CDselections.districtName = 'District';
					CDselections.abrvState = 'US';
					CDselections.stateName = 'State';
				}
			}

			// if there is an active (on) category, then that selectedlayer flag should be true
			// activeCategoryID.length ? showOnlySelectedLayer = true : showOnlySelectedLayer = false;
			showOnlySelectedLayer = Boolean(activeCategoryID.length)

			// user cleared the search so clear the input field
			if (requestQuery === '' && shouldClear) {
				clearAutocomplete = true;
				this.setElem('search-input', '');
			}
			else {

				if (this.getElem('search-input') === '' && Object.prototype.hasOwnProperty.call(inputObj, 'raw') && inputObj.raw !== '') {
					this.setElem('search-input', inputObj.raw);
				}
			}

			this.setState({
				mapCenter: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					lng: this.state.isMobile ? -98 : -105,
					// eslint-disable-next-line react/no-access-state-in-setstate
					lat: this.state.isMobile ? 32 : 39,
				},
				results: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state.results,
					currentRequest: data.specs.text || requestQuery,
					isLoading: true,
					input: inputObj,
					showOnlySelectedLayer,
					requestType,
					reZoom: true,
					showFilter: false,
					currentSearch: invalidZip ? `${inputObj.raw} is an invalid zip code.` : currentSearch,
					resultsPos: 0,
					filterType: filterType || 'keyword',
					isNearbySearch: isLocationSearch,
					totalResults: data && data.total ? data.total : 0,
					searchResultsByCategory: resultsByCategory,
					coordinates: data.coordinates,
					bounds: data.bounds,
					showListView: false,
					origin,
					activeCategoryID,
					invalidZip,
					clearAutocomplete,
				},
				congress: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state.congress,
					currentNav: 'list',
					filter: CDfilter,
					mapbox: {
						zoom: CDcoordinates.zoom,
						pitch: CDcoordinates.pitch,
						rotation: CDcoordinates.rotation,
						center: CDcoordinates.center,
						districts: {},
					},
					orgs: data && data.list,
					selected: CDselections,
					state: data.specs.type === 'region',
					type: filterType === 'category',
					organizations: {
						// eslint-disable-next-line react/no-access-state-in-setstate
						...this.state.congress.organizations,
						bySearch: data && data.list,
					},
					searchType: isDistrictExp ? data.specs.type : '',
				},

				search: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state.search,
					results: { ...search },
				},

			});

			if (isDistrictExp) {
				// not supposed to be able to set state like this
				this.state.search.results.queryString = this.state.search.results.queryString.replace('target=district&', '');

				this.routeToMap().then(() => {
					this.setState({
						mapLoading: false,
					}, () => {
						window.setTimeout(() => openNavTimer(), 1000);

					});

				});
			}

			// when resetting the map, we also clear the Mapbox GeoCoder using
			// their .clear() method. Their method RETURNS focus back the text input
			// which in turn, on MOBILE devices, keeps the soft keyboard open. So
			// we set focus to the magnifying glass buttons after the reset
			// logic is complete. Otherwise the soft keyboard on mobile keeps opening.
			this.state.isMobile && shouldClear && document.getElementById('search-btn').focus();

		};


		if (origin === 'home') {
			// NOTE: HOME MAP SEARCH SUBMIT
			this.setState({
				mapLoading: true,
				closeNav: toggleNavClose(),
			}, () => {
				//GAfireEvent('C31', { category: false, action: false, label: this.state.results.input.raw });
				executeSearch();
			},
			);
		}

		else if (origin === 'sustainability') {
			// NOTE: SUSTAINABILITY MAP SEARCH SUBMIT
			this.setState({
				mapLoading: true,
				closeNav: toggleNavClose(),
			}, () => {
				//GAfireEvent('isf_C24-new', { category: false, action: false, label: this.state.results.input.raw });
				executeSearch();
			},
			);
		}

		else {
			// NOTE: HOME MAP SEARCH SUBMIT
			this.setState({
				mapLoading: true,
				closeNav: toggleNavClose(),
			}, () => {
				//GAfireEvent('C31', { category: false, action: false, label: this.state.results.input.raw });
				executeSearch();
			},
			);
		}
	};

	parseQueryString = queryString => {
		const qStringFormatted = decodeURI(queryString).toLowerCase(); // .replace(/-+/g, ' ')

		const search =
			qStringFormatted !== ''
				? qStringFormatted
					.slice(1)
					.split('&')
					.map(queryParam => {
						const kv = queryParam.split('=');
						return { key: kv[0], value: kv[1] };
					})
					.reduce(
						(parsed, kv) => {
							const parsedWorking = { ...parsed }; // must copy var 'parsed' and create new mem location for its contents to preserve integrity of original var 'parsed'. Avoids 'no-param-reassign' error
							parsedWorking[kv.key] = kv.value;
							if (kv.key === 'category')
								parsedWorking.categoryKey = getCommunityId(kv.value.replace(/-+/g, ' '));
							return parsedWorking;
						},
						{ queryString: qStringFormatted },
					)
				: false;

		const { location } = this.props;
		const route = location.pathname;
		const isMap = route === '/map/';
		const isOrganization = route === '/organization/';
		//const isDistrict = route === '/district/';
		const isDistrict = true;

		this.setState({
			search: {
				results: isMap ? search : { ...search },
				organizations: isOrganization ? search : { ...search },
				districts: isDistrict ? search : { ...search },
			},
		});

		return search;
	};

	/////////////////////////////////////////////////////////////////////////
	// Function to help when deep linking into a view via URL params
	/////////////////////////////////////////////////////////////////////////
	checkForCityOrZip = async obj => {
		let matchObj = {};

		// Our Geocode PHP API endpoint call - called from below.
		const geoCode = async (txt) => fetch(`${process.env.PUBLIC_URL}/api/geocode.php?geocode=${txt}`)
			.then(response => (response.ok ? response.json() : Promise.reject(new Error('geocode data was not received'))))
			.catch(err => console.error(err));

		if (obj.fromURL) {
			// request came from URL (deep linked with search= parameter)

			// checks if our URL param ONLY contains just a u.s. state
			const onylyUSstate = US_STATES_BOUNDS.find(usState => (usState.abrv.toLowerCase() === obj.text || usState.state.toLowerCase() === obj.text));

			if (!onylyUSstate) {
				// URL params did NOT contain just a U.S. state.
				// so we prep its info to be able to Geocode it - to see if its a valid city or valid zip code
				let geoCodeCriteria = '';
				matchObj.features = [];

				const fiveDigits = obj.text.match(/\b\d{5}\b/g);
				if (fiveDigits !== null) {
					// URL parameter had 5 numerical digits in a row - so treat it like a zip code
					geoCodeCriteria = fiveDigits[0];
					matchObj.type = 'postcode';
				}
				else {
					// URL isn't just a zip code
					// treat comma delimited url search values as possible city and state searches
					// but we only do a city search if the url terms contains a valid U.S. state
					// without a U.S. state, then a city name is treated as a keyword search
					let stateFound = false;
					const textArray = obj.text.split(',').map(item => item.trim());
					textArray.forEach(term => {
						stateFound = US_STATES_BOUNDS.find(usState => (usState.abrv.toLowerCase() === term || usState.state.toLowerCase() === term));
					});

					stateFound
						? (geoCodeCriteria = obj.text, matchObj.type = 'place')
						: (matchObj.type = 'keyword');
				}

				if (geoCodeCriteria.length) {
					const geocodingResponse = await geoCode(geoCodeCriteria);
					// if Mapbox Gecoder returns a feature using the passed in city, state with a relevance of 1, then use that
					// otherwise, the city and state inputs did not return any results, so must be invalid city.
					matchObj.features = [];
					matchObj.validLocation = false;

					if (geocodingResponse.features.length && geocodingResponse.features[0].relevance === 1) {
						matchObj = geocodingResponse.features[0];
						matchObj.validLocation = true;
					}
				}
			}
			else {
				matchObj.features = [];
				matchObj.type = 'region';
				matchObj.validLocation = true;
			}
		}
		else {
			// request came from autocomplete component

			// lets see if request from autocomplete was just a zipcode
			const fiveDigits = obj.text.match(/\b\d{5}\b/g);
			fiveDigits !== null ? matchObj.type = 'postcode' : matchObj.type = 'place';

			// initially assume there is no match from geocode
			matchObj.features = [];
			matchObj.validLocation = false;

			let textCriteria;
			Object.prototype.hasOwnProperty.call(obj, 'text')
				? textCriteria = obj.text
				: textCriteria = obj;
			const geocodingResponse = await geoCode(textCriteria);

			if (geocodingResponse.features.length) {
				// got a feature result back from Mapbox GeoCoder API
				if (geocodingResponse.features[0].relevance === 1) {
					// only take a feature when the relevance is 1 (exact match)
					matchObj = geocodingResponse.features[0];
					matchObj.validLocation = true;

					if (geocodingResponse.features[0].place_type[0] === 'country' && geocodingResponse.features[0].place_name === 'United States') {
						// workaround for United State returned in Geocode (can't filter it since we need to GeoCode Puerto Rico)
						// if user types in 'united' in search field, need to skip first feature (which is USA), and instead
						// take 2nd feature in JSON response.
						matchObj = geocodingResponse.features[1];
						matchObj.validLocation = true;
					}
				}
			}
		}
		return Promise.resolve(matchObj);
	};

	trimUSA = placeName => {
		const itemArray = placeName.split(', ');

		return itemArray[itemArray.length - 1] === 'United States' ? itemArray.pop() && itemArray.join(', ') : placeName;
	};

	/////////////////////////////////////////////////////////////////////////
	// Function to scroll window from disclaimer references in body
	// to disclaimer text in footer, and vice versa
	/////////////////////////////////////////////////////////////////////////
	goToAnchor = async (evt, extra = 0) => {
		evt.preventDefault();

		const eventTarget = evt.currentTarget;
		const targetAnchor = document.getElementById(eventTarget.dataset.goTo);

		window.scrollTo({
			top: window.pageYOffset + targetAnchor.getBoundingClientRect().top - extra,
			behavior: 'smooth',
		});
	};


	/////////////////////////////////////////////////////////////////////////
	// DEEP LINKING SEARCH LOGIC USING URL PARAMS
	/////////////////////////////////////////////////////////////////////////
	handleQueryUrl = async route => {
		const { search } = this.state;
		const inputObj = {
			text: search.results.search || '',
			categoryKey: search.results.categoryKey || '',
			category: search.results.category || '',
			fromURL: true,
			place_type: '',
		};
		let filterType = '';

		if (route === 'sustainability') {
			this.props.history.push({
				pathname: '/sustainability/',
				// search: search.organizations.queryString,
			});
		}
		if (route === 'org') {
			this.props.history.push({
				pathname: '/organization/',
				search: search.organizations.queryString,
			});
		}

		if (route === 'map') {
			const state = search.districts.state || '';
			const district = search.districts.district || '';
			const categoryKey = search.districts.category ? getMapboxIdFromOrgDash(search.districts.category) : false;
			const category = categoryKey ? IDS_TO_COMMUNITIES[categoryKey] : '';
			const { stateFilter, districtFilter, districtResult = {} } = this.getFilteredDistricts(search.districts);
			const isStateFilter = stateFilter;
			const searchType = inputObj.place_type;
			const isCategoryFilter = typeof categoryKey !== 'undefined' ? categoryKey : false;
			const fetchCategory = (categoryKey) || 'all';
			const fetchState = (stateFilter) ? state : 'all';
			const fetchDistrict = (!stateFilter || !districtFilter) ? 'all' : state + district;
			let filter, stateName, districtName;
			let categoryId, categoryName, abrvState, stateCategory, stateDistrict;
			if (isCategoryFilter) {
				filter = 'url';
				stateName = 'State';
				districtName = 'District';
				stateDistrict = 'US';
				abrvState = (isStateFilter) ? state : 'US';
				stateCategory = category;
				categoryId = categoryKey;
				categoryName = category;
				filterType = 'category';
			}

			if (isStateFilter) {
				filter = 'url'; // districtSearch ? 'district' : 'state';
				stateName = US_STATES_BOUNDS.find(_ => _.abrv.toLowerCase() === state).state;
				districtName = districtFilter ? districtResult.alt_district_val : 'District';
				abrvState = state.toUpperCase();
				stateDistrict = districtFilter ? district : 'US';
				stateCategory = isCategoryFilter ? category : '';
				categoryName = isCategoryFilter ? category : '';
				categoryId = isCategoryFilter ? categoryKey : '';
				filterType = 'region';

				this.setDistrictUIData({
					abrvState,
					stateName,
				});
			}

			// ID district without a state
			if (!isStateFilter && !stateFilter && !districtFilter && district === '') {
				filter = 'url'; // districtFilter ? 'district' : 'state';
				stateName = 'State';
				districtName = 'District';
				abrvState = 'US';
				stateDistrict = 'US';
				stateCategory = isCategoryFilter ? category : '';
				categoryName = isCategoryFilter ? category : '';
				categoryId = isCategoryFilter ? categoryKey : '';
			}

			// deferring deep linking of search values on CD for now
			// only supporting state and district deep linking
			// so if queryString has search= on the district map page, remove it.
			const newQS = this.updateQueryStringParameter(
				search.districts.queryString || '',
				'search',
				'',
			);

			this.filterOrgs(fetchCategory, fetchState, fetchDistrict, searchType).then(async results => {
				const update = {
					results: {
						...this.state.results,
						resultsPos: 0,
						showFilter: false,
						requestType: 'url',
						filterType,
					},
					congress: {
						...this.state.congress,
						filter: filter || 'search',
						currentNav: 'list',
						selected: {
							...this.state.congress.selected,
							stateName,
							districtName,
							abrvState,
							district: stateDistrict,
							category: stateCategory,
							categoryName,
							categoryId,
						},
						orgs: results.search,
						filterDistrict: {
							state: false,
							congressDistrict: false,
						},
						state: stateFilter,
						type: isCategoryFilter,
						organizations: {
							...this.state.congress.organizations,
							all: this.state.results.all,
							byDistrict: (districtName === 'District') ? [] : results.dist,
							byState: (stateName === 'State') ? [] : results.state,
						},
						searchType: inputObj.place_type,
					},
					search: {
						...this.state.search,
						districts: {
							queryString: newQS,
						},
					},
				};

				firstUpdate = update.results;
				this.setState(update);

				// this.props.history.push({
				//     pathname: '/district/',
				//     search: this.state.search.districts.queryString,
				// });
			}).then(() => {
				this.setState({
					loadingFilter: false,
				});
			}).then(() => {
				setTimeout(() => {
					this.setState({
						closeNav: false,
					});
				}, 1000);
			});


		}
	};

	handleEvent = event => {

		// console.log('handleEvent');
		switch (event.action) {
			case 'showMore':
				this.showMore(event);
				break;
			case 'stop-zoom':
				this.setState((prevState) => ({
					results: {
						...prevState.results,
						reZoom: false,
					},
				}));
				break;
			case 'toggle':
				this.handleUIToggle(event);
				break;
			case 'slide-list-view':
				this.slideListView(event);
				break;
			case 'search':
				this.handleSearch(event);
				break;
			case 'input':
				this.handleInputChange(event);
				break;
			case 'mapClick':
				this.handleMapClick(event);
				break;
			case 'show-all':
				this.showAll(event);
				break;
			case 'back':
				locationHistory.pop();
				this.props.history.goBack();
				if (locationHistory[locationHistory.length - 1] === '/' || locationHistory.length === 0) {
					this.clearSearch(event);
				}
				break;
			case 'init-done':
				console.log('init-done');
				this.setState((prevState) => ({
					results: {
						...prevState.results,
						initialFeaturesLoaded: true,
					},
				}));
				// this.props.history.replace({ key: this.props.this.props.history.location.key, state: this.state});
				break;
			case 'update-results':
				this.updateResults(event.data);
				break;
			case 'clear-search':
				this.clearSearch(event);
				break;
			default:
				break;
		}
	};

	handleUIToggle = params => {

		const stateKey = `show${params.type}`;

		if (stateKey === 'showFilter' && !this.state[params.name].showFilter) {
			this.setState((prevState) => ({
				[params.name]: {
					...prevState[params.name],
					[stateKey]: !prevState[params.name][stateKey],
				},
				// these next statements close the individual congressional district Filters (if open)
				congress: {
					...prevState.congress,
					filterDistrict: {
						state: false,
						congressDistrict: false,
					},
				},
			}));

			// this.props.history.replace({ key: this.props.history.location.key, state: this.state});

		}
		else {
			this.setState((prevState) => ({
				[params.name]: {
					...prevState[params.name],
					[stateKey]: !prevState[params.name][stateKey],
					showFilter: false,
				},

			}));


			// this.props.history.replace({ key: this.props.history.location.key, state: this.state});

		}

	};

	slideListView = () => {
		// this shows and hides the desktop list results
		this.setState((prevState) => ({
			results: {
				...prevState.results,
				hideListViewDesktop: !prevState.results.hideListViewDesktop,
			},
			closeNav: !prevState.closeNav,
		}));
	};

	setElem = (id, val) => {
		// set the text search input element
		document.getElementById(id).value = val;
	};

	// set the text search input element
	getElem = (id) => document.getElementById(id).value;

	getFilteredDistricts = requestQuery => {
		// console.log('getFilteredDistricts');
		const { state: requestState, district: requestDistrict } = requestQuery;

		// If state abbr passed ? is abbr is valid : false
		const stateResult = (US_STATES_BOUNDS.find(usState => usState.abrv.toLowerCase() === requestState));
		const stateFilter = typeof stateResult !== 'undefined' ? stateResult : false;
		const districtResult = US_DISTRICTS.find(district => (district.state.toLowerCase() === requestState) && (district.district_num === requestDistrict));
		const districtFilter = typeof districtResult !== 'undefined' ? districtResult : false;

		return {
			stateFilter,
			stateResult,
			// If district passed ? is passed district number valid for the passed state : false
			districtFilter,
			districtResult,
		};
	};

	clearSearch(event) {
		// console.log('clearSearch');
		this.setState((prevState) => ({
			results: {
				...prevState.results,
				input: {},
				requestType: 'search',
				currentRequest: '',
				resultsPos: 0,
				showFilter: false,
				showOnlySelectedLayer: false,
				showListView: false,
				searchResultsByCategory: prevState.results.totalResultsByCategory,
				totalResults: 0,
				reZoom: true,
				filterType: null,
				isLoading: false,
				activeCategoryID: '',
			},
			home: {
				...prevState.home,
				input: {},
			},
			search: {
				results: {
					search: null,
					categoryKey: null,
					queryString: null,
					category: null,
				},
				organizations: {
					search: null,
					queryString: null,
				},
				featured: {
					categoryKey: null,
					queryString: null,
					category: null,
				},
			},
		}), (prevState) => {
			if (event.type === 'reset-map') {
				this.props.history.push({
					pathname: '/map/',
					search: '',
					state: prevState,
				});
			}
		});
	}

	checkMobile() {
		// const isMobile = window.innerWidth < 768 || false;
		const isMobile = window.innerWidth < 768 || false;

		const update = {
			isMobile,
		};

		this.setState(update);

		return isMobile;
	}

	// eslint-disable-next-line class-methods-use-this
	firePartnerTags(route) {
		if (route === '/') {
			/*
			// DCM Floodlight tag for Home Page
			const axel = `${Math.random()}`;
			// Verizon Media Tag for home page - setup snippet in index.html
			window.dotq = window.dotq || [];
			window.dotq.push({
				'projectId': '10000',
				'properties': {
					'pixelId': '10028472',
					'qstrings': {
						'et': 'custom',
						'ec': '2021_ENT_H2_HopeUSA_PageLoad_Verizon',
					},
				},
			});

			// Twitter Tag
			window.twq('init', 'nv76p');
			window.twq('track', 'PageView');

			// Facebook Tag
			window.fbq('init', '1578146899100389');
			window.fbq('track', 'PageView');
			window.fbq('trackCustom', 'ENT_H2-HopeUSA_Page_Impact_Pageview');

			// Pinterest Tag
			window.pintrk('load', '2613791476819', { em: '<user_email_address>' });
			window.pintrk('page');
			*/
		}
	}

	getResults = async () => {

		// console.log('getResults');

		const { location } = this.props;
		const route = location.pathname;
		const search = this.parseQueryString(location.search);
		const totalResults = await resetResults();
		const { all } = totalResults;

		if (search && search.target !== 'map') {
			switch (route) {
				// case '/map/':
				//     this.setState((prevState) => ({
				//         results: {
				//             ...prevState.results,
				//             totalResultsByCategory: totalResults.list,
				//             all: totalResults.all
				//         },
				//     }));
				//     this.handleQueryUrl('map');
				//     break;
				case '/organization/':
					this.setState((prevState) => ({
						results: {
							...prevState.results,
							totalResultsByCategory: totalResults.list,
							searchResultsByCategory: totalResults.list,
							originalTotal: totalResults.total,
							all: totalResults.all,
						},
						congress: {
							...prevState.congress,
							orgs: totalResults.all,
							organizations: {
								...prevState.congress.organizations,
								all,
								byDistrict: [],
								byState: [],
								bySearch: [],
							},
						},
					}));
					await this.handleQueryUrl('org');
					break;
				case '/sustainability/':
					this.setState((prevState) => ({
						sustainability: {
							...prevState.results,
							totalResultsByCategory: totalResults.list,
							searchResultsByCategory: totalResults.list,
							originalTotal: totalResults.total,
							all: totalResults.all,
						},
						congress: {
							...prevState.congress,
							orgs: totalResults.all,
							filter: 'url',
							// filter: 'search',
							organizations: {
								...prevState.congress.organizations,
								all,
								byDistrict: [],
								byState: [],
								bySearch: [],
							},
							searchType: '',
						},
					}));
					await this.handleQueryUrl('sustainability');
					break;
				case '/map/':
					this.setState((prevState) => ({
						results: {
							...prevState.results,
							searchResultsByCategory: totalResults.list,
							totalResultsByCategory: totalResults.list,
							originalTotal: totalResults.total,
							all,
						},
						congress: {
							...prevState.congress,
							orgs: totalResults.all,
							filter: 'url',
							// filter: 'search',
							organizations: {
								...prevState.congress.organizations,
								all,
								byDistrict: [],
								byState: [],
								bySearch: [],
							},
							searchType: '',
						},
					}));
					await this.handleQueryUrl('map');
					break;
				default:
					this.setState((prevState) => ({
						results: {
							...prevState.results,
							searchResultsByCategory: totalResults.list,
							totalResultsByCategory: totalResults.list,
							originalTotal: totalResults.total,
							all,
						},
						congress: {
							...prevState.congress,
							orgs: totalResults.all,
							// filter: 'url',
							organizations: {
								...prevState.congress.organizations,
								all,
								byDistrict: [],
								byState: [],
								bySearch: [],
							},
							searchType: '',
						},
					}));
					break;
			}
		}
		else {
			this.setState((prevState) => ({
				results: {
					...prevState.results,
					searchResultsByCategory: totalResults.list,
					totalResultsByCategory: totalResults.list,
					originalTotal: totalResults.total,
					all,
				},
				congress: {
					...prevState.congress,
					orgs: totalResults.all,
					organizations: {
						...prevState.congress.organizations,
						all,
						byDistrict: [],
						byState: [],
						bySearch: [],
					},
					searchType: '',
				},
			}));
		}
	};

	// ///////////////////////////////////////////////////////
	// REACT APP HAS MOUNTED
	// ///////////////////////////////////////////////////////
	componentDidMount = async () => {
		console.log('APP MOUNT');


		const isMobile = this.dealWithMobile(this);
		const { location } = this.props;
		const route = location.pathname;
		const search = this.parseQueryString(location.search);

		locationHistory.push(route);

		this.firePartnerTags(route);

		this.setState((prevState) => ({
			mapLoading: true,
			alreadyShown: false,
			appData: {
				...prevState.appData,
			},
			// To prevent blank featured page if user refresh on featured page - UX TBD
			featured: {
				...prevState.featured,
			},
			home: {
				...prevState.home,
				showFilter: false,
			},
			results: {
				...prevState.results,
				showFilter: false,
				showListView: false,
			},
			isMobile,
			congress: {
				...prevState.congress,
				filter: (search && route !== '/organization/' && route !== '/') ? 'url-loading' : '', // only set filter to url-loading when have a querystring, but not on org detail page.
			},
		}));

		await this.getResults();

		this.setState({
			mapLoading: false, // turns off the loading overlay and animated circle on the DEFAULT experience
			loadingFilter: false, // turns off the loading overlay and animated circle on the CONGRESS experience
			alreadyShown: true,
		},
			() => {
				setTimeout(() => {
					this.setState({
						closeNav: false,
					});
				}, 1000);
			});

		fetch(`${process.env.PUBLIC_URL}/api/?is_featured`)
			.then(response => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(new Error('data was not received'));
			})
			.then(featuredOrgs => {
				this.setState((prevState) => ({
					appData: {
						...prevState.appData,
						featuredOrgs: featuredOrgs.features,
					},
					results: {
						...prevState.results,
						featuredOrgs: featuredOrgs.features,
					},
				}));
			});

		if (route === '/' || route === '/housing/') {
			// only need to do linking to/fro disclaimer on home page
			this.disclaimerLinking();
		}

	};

	componentDidUpdate(prevProps, prevState) {

		const { location } = this.props;
		const route = location.pathname;
		const prevRoute = prevProps.location.pathname;

		const hasNotGoneBackToPreviousPage = locationHistory[locationHistory.length - 1] !== route;

		if ( hasNotGoneBackToPreviousPage) {
			locationHistory.push(route);
		}

		// console.log('route ', route)

		if (route === '/' && this.state.results.initialFeaturesLoaded) {
			this.setState((state) => ({
				results: {
					...state.results,
					initialFeaturesLoaded: false,
				},
			}));
			// this.props.location.state = this.state;
			// this.props.history.replace({ key: this.props.history.location.key, state: this.state});
		}

		// Do not not show map unless no search has been run
		if (this.state.results.currentRequest !== '' && this.state.results.showAll) {
			this.setState((state) => ({
				results: {
					...state.results,
					showAll: false,
				},
			}));
			// this.props.location.state = this.state;
			// this.props.history.replace({ key: this.props.history.location.key, state: this.state});
		}

		// IF it's a redirect from district to map, get results again
		if (prevRoute === '/district/' && route === '/map/') {
			this.getResults();
		}


		//FROM IMPACT-MERGE
		// const dataPage = (route.indexOf('?') > -1) ? route.substring(0, route.indexOf('?')).replace(/\//g, '') : route.replace(/\//g, '');


		let dataPage;

		if (route.split('/').length > 3) {
			dataPage = "articles"
		}
		else {
			dataPage = (route.indexOf('?') > -1) ? route.substring(0, route.indexOf('?')).replace(/\//g, '') : route.replace(/\//g, '');


		}

		if (dataPage === 'esimpacthousing') {
			document.documentElement.setAttribute('data-page', 'housing');
			document.body.setAttribute('data-page', 'housing');
		}
		else {
			document.documentElement.setAttribute('data-page', route === '/' ? 'home' : dataPage);
			document.body.setAttribute('data-page', route === '/' ? 'home' : dataPage);
		}


		stateRun++;

		if (route.indexOf('district') > -1 || route.indexOf('map') > -1) { // disctrict map page or default map page
			// setup an event listener if any dropdown is open so if the user clicks/taps outside those, they will close.
			const entirePage = document.getElementById('root');
			if (document.getElementsByClassName('list-dropdown open').length > 0 || (this.state.isMobile && document.getElementById('filter-menu') && document.getElementById('filter-menu').classList.contains('open'))) {
				entirePage.addEventListener('mousedown', this.handleClickOutside);
				entirePage.addEventListener('touchstart', this.handleClickOutside);
			}
			else {
				entirePage.removeEventListener('mousedown', this.handleClickOutside);
				entirePage.removeEventListener('touchstart', this.handleClickOutside);
			}
		}
	}

	componentWillUnmount() {

		document.removeEventListener('mousedown', this.handleClickOutside);
		document.removeEventListener('touchstart', this.handleClickOutside);
	}

	handleMapClick(e) {
		this.setState({
			mapCenter: e.center,
		});

		// this.props.history.replace({ key: this.props.history.location.key, state: this.state});
	}

	dealWithMobile(_) {
		const isMobile = this.checkMobile();
		window.addEventListener('resize', this.checkMobile.bind(_));
		return isMobile;
	}

	updateResults(data) {
		// console.log('updateResults');
		const currTotal = this.state.results.totalResults;
		const { isNearbySearch } = this.state.results;
		// not ideal but there is a loop regarding zoom/updatemap sometimes
		const isLocationSearch = ['postcode', 'place'].indexOf(data.specs.type) > -1;
		if (currTotal !== data.total || isLocationSearch || isNearbySearch) {
			this.setState((prevState) => ({
				results: {
					...prevState.results,
					searchResultsByCategory: {
						...prevState.results.searchResultsByCategory,
						...data.list,
					},
					totalResults: data.total,
					isNearbySearch: data.meta || isNearbySearch,
					coordinates: data.coordinates,
					bounds: data.bounds || prevState.results.bounds,
				},
			}));

			// this.props.history.replace({ key: this.props.history.location.key, state: this.state});
		}
	}

	async routeToMap(ctrlKey) {
		const { history } = this.props;
		const { search } = this.state;
		//CHANGE
		if (ctrlKey) {
			window.open('/map/', '_blank');
		}
		else {
			window.setTimeout(() => {
				history.push({
					// pathname: `/map/`,
					pathname: `/map/${search.results.queryString}`,
					// search: search.results.queryString,
				});
			}, 500);
		}
	}

	showAll() {

		// console.log('showAll');
		this.props.history.push({
			pathname: '/map/',
			search: '',

		});
		this.setState((prevState) => ({
			results: {
				...prevState.results,
				showListView: false,
				showAll: true,
			},
		}));

		// this.props.history.replace({ key: this.props.history.location.key, state: this.state});

	}

	////////////////////////////////////////////////////////
	// PAGINATION FUNCTION
	////////////////////////////////////////////////////////
	showMore({ name, type }) {

		const {isMobile } = this.state;
		const routeState = this.state[name];
		let typeKey = `${type}Pos`;
		const currPos = routeState[typeKey];
		let nextStartPos;
		if (name === 'featured') {
			nextStartPos = currPos + (isMobile ? 1 : 3);
		}
		else if (name === 'results') {
			typeKey = `${name}Pos`;
			nextStartPos = (type - 1) * RESULTS_PER_PAGE;
		}

		this.setState({
			[name]: { ...routeState, [typeKey]: nextStartPos },
		});

		// this.props.history.replace({ key: this.props.history.location.key, state: this.state});
		// scroll results list to top on page change.
		document.querySelector('.organizations__results-list').scrollTop = 0;
	}

	toggleCongressDropdowns = (update) => {
		const filterClicked = update.split('-')[0];
		let filterClickedStatus = update.split('-')[1]; // results in string

		filterClickedStatus = JSON.parse(filterClickedStatus); // changes the string to actual boolean value

		const otherFilter = filterClicked === 'state' ? 'congressDistrict' : 'state';
		let otherFilterClickedStatus = filterClickedStatus;

		if (this.state.congress.filterDistrict[filterClicked] === true && filterClickedStatus === true) {
			// closing the filter, so make sure the other filter gets closed too
			otherFilterClickedStatus = false;
		}

		this.setState((prevState) => ({
			// close category filter dropdown ONLY when in mobile, since we just opened a state or district dropdown
			results: {
				...prevState.results,
				showFilter: prevState.isMobile && false,
			},
			// close other dropdown when different dropdown is opened
			congress: {
				...prevState.congress, filterDistrict: {
					...prevState.congress.filterDistrict,
					[filterClicked]: !filterClickedStatus,
					[otherFilter]: otherFilterClickedStatus,
				},
			},
		}));

	};

	resetMap = async () => {

		// console.log('resetMap');

		const state = {
			loadingFilter: true,
			results: {
				...this.state.results,
				clearAutocomplete: true,
			},
			// closeNav: true,  // uncomment to have it open and close on each filter
		};


		this.setState(state, () => {

			this.setElem('search-input', '');

			const { all } = this.state.results;
			const { isMobile } = this.state;

			const update = {
				results: {
					...this.state.results,
					filterType: '',
					currentRequest: '',
					currentSearch: '',
					input: {},
					isLoading: false,
					invalidZip: false,
					totalResults: this.state.results.originalTotal,
					resultsPos: 0,
					clearAutocomplete: false,
				},
				congress: {
					...this.state.congress,
					filter: '',
					currentNav: 'default',
					selected: {
						...this.state.congress.selected,
						stateName: 'State',
						abrvState: 'US',
						district: 'US',
						districtName: 'District',
						categoryId: '',
						category: '',
						categoryName: '',
					},
					orgs: all,
					mapbox: {
						zoom: isMobile ? 2.2 : 3.5, // DEFAULT MAP ZOOM level for district experience on page load
						rotation: -10,
						center: isMobile ? [-98, 32] : [-105, 39], // DEFAULT MAP CENTER for district experience on page load
						districts: {},
					},
					filterDistrict: {
						state: false,
						congressDistrict: false,

					},
					state: false,
					type: false,
					districts: [],
					organizations: {
						all,
						byDistrict: [],
						byState: [],
					},
					searchType: '',
				},
				search: {
					...this.state.search,
					results: {
						...this.state.search.results,
						search: null,
						categoryKey: null,
						queryString: null,
						category: null,
					},
				},
			};

			this.setState(update);

			this.props.history.push({
				pathname: '/district/',
				search: null,
			});
		});

		setTimeout(() => {
			this.setState({
				loadingFilter: false,
				// closeNav: false,  // uncomment to have it open and close on each filter
			});
		}, 1000);

	};

	/////////////////////////////////////////////////////////////////////////
	// DISTRICT EXPERIENCE - FUNCTION TO GET DISTRICT DATA FOR
	// THE SELECTED STATE FOR THE DISTRICT DROPDOWN
	/////////////////////////////////////////////////////////////////////////
	setDistrictUIData = (prop) => {
		// console.log('setDistrictUIData');
		let districtUIData = [];

		const { stateName, abrvState } = prop;

		const FoundState = US_STATES_BOUNDS.find(usState => usState.state === stateName);
		const { coordinates } = FoundState;

		const districtFilter = (data) => {

			const filterDropdownState = data.features.filter(district => district.state === abrvState);

			// districtUIData is an state filtered ARRAY
			// districtEach is an object of each district number and its dropdown display
			districtUIData = [];
			let districtEach = {};

			filterDropdownState.forEach(district => {
				districtEach = {};
				districtEach.numeral = Number(district.district_num);
				districtEach.display = district.alt_district_val;
				districtEach.zoom = district.zoom;
				districtUIData.push(districtEach);
			});

			// have to sort the district data since JSON dose not retain SQL sorted results
			districtUIData.sort((a, b) => (a.numeral > b.numeral) ? 1 : -1);

			// add 'All Districts' to beginning of district data array
			if (districtUIData.length > 1) { // only add 'All Districts' when more than 1 district in State.
				districtEach = {};
				districtEach.numeral = 'US';
				districtEach.display = 'All Districts';
				districtEach.zoom = 4;
				districtUIData.unshift(districtEach); // add to beginning of array
			}

			this.setState((prevState) => ({
				...prevState,
				congress: {
					...prevState.congress,
					districts: districtUIData,
					// filter: 'url',
					mapbox: {
						zoom: coordinates.zoom,
						pitch: coordinates.pitch,
						rotation: coordinates.rotation,
						center: coordinates.center,
						districts: {},
					},

				},
			}));
		};

		fetch(`${process.env.PUBLIC_URL}/api/congress.php`)
			.then(data => data.json())
			.then(data => districtFilter(data));


	};

	/////////////////////////////////////////////////////////////////////////
	// DISTRICT EXPERIENCE - FUNCTION WHEN CATEGORY FILTER SELECTED
	/////////////////////////////////////////////////////////////////////////
	chooseDropdownType = (prop, origin) => {
		// console.log('chooseDropdownType');
		this.setState({
			loadingFilter: true,
			// closeNav: true, // uncomment to have it open and close on each filter
			mapLoading: true,
		}, () => {
			let { currentSearch, filterType } = this.state.results;
			const { selected, searchType } = this.state.congress;
			const source = origin || 'congress';
			let { abrvState, district, stateName, districtName } = selected;
			const category = prop;

			const categoryId = getCommunityId(prop);

			// here is where category selection or de-selection occurs.
			// if the selected category matches what was previously selected, then
			// it is a de-selection
			const categoryName =
				(category === selected.categoryName
					&& origin !== 'home'
					&& origin !== 'organization'
					&& origin !== 'sustainability')
					? ''
					: category;

			const isOrgDetailPage = window.location.pathname.indexOf('organization') > -1;

			const fetchCatId = (categoryId === '' || categoryName === '') ? 'all' : categoryId;
			let fetchState = (abrvState === 'US') ? 'all' : abrvState;
			let fetchDistrict = (abrvState === 'US' || district === 'US') ? 'all' : abrvState + district;
			let prevSearchType = searchType;
			const prevFilterType = filterType;

			filterType = 'category';

			// category de-selection logic
			if (fetchCatId === 'all') {
				// user de-selected a category
				if (prevSearchType !== '') {
					// text search occurred, so when de-selecting a category, revert filterType back to search type
					filterType = prevFilterType;
					if (filterType === 'place' || filterType === 'postcode') {
						// place and postcode are considered location filterType
						filterType = 'location';
					}
				}
				else {
					// search type was blank (so text search in place)
					if (selected.stateName !== 'US') {
						// a state was selected, so revert filter to 'region'
						filterType = 'region';
					}
					else {
						// no state selected, so filterType is nothing.
						filterType = '';
					}
				}
			}
			else if (source === 'home' || source === 'organization' || source === 'sustainability') {
				// category selected from org detail or home page, so clear other search settings.
				prevSearchType = '';
				fetchState = 'all';
				fetchDistrict = 'all';
				currentSearch = '';

				// reset any selected states or districts when coming from home or org detail page.
				abrvState = 'US';
				district = 'US';
				districtName = 'District';
				stateName = 'State';

			}

			this.filterOrgs(fetchCatId, fetchState, fetchDistrict, prevSearchType).then(async results => {

				// const typeCategoryValue = prop.split('+')[0];
				// const selectedCategory = prop.split('+')[1];

				let newQs = this.updateQueryStringParameter(
					this.state.search.results.queryString || '',
					'category',
					(categoryName === '') ? '' : formatMapboxId(category),
				);

				if (isOrgDetailPage) {
					// remove the search=*** querystring from URL if it has it and was on org detail page
					newQs = this.updateQueryStringParameter(
						newQs || '',
						'search',
						'',
					);
				}

				// remove the target=district querystring from URL if it has it - we will route to district map below
				newQs = this.updateQueryStringParameter(
					newQs || '',
					'target',
					'',
				);

				const update = {
					search: {
						...this.state.search,
						results: {
							queryString: newQs,
						},
					},
					results: {
						...this.state.results,
						activeCategoryID: categoryName === '' ? '' : categoryId,
						resultsPos: 0,
						showFilter: false,
						currentSearch,
						filterType,
					},
					congress: {
						...this.state.congress,
						filter: 'type',
						currentNav: 'list',
						searchType: prevSearchType,
						selected: {
							...this.state.congress.selected,
							category: categoryName,
							categoryName,
							categoryId: categoryName === '' ? '' : categoryId,
							abrvState,
							district,
							districtName,
							stateName,
						},
						orgs: results.search,
						organizations: {
							...this.state.congress.organizations,
						},
					},
				};

				this.ResultsBacktoTop();
				this.setState(update);
				await this.routeToMap();

				setTimeout(() => { // React code runs faster than map, so show loader for .3 seconds when selecting categories
					this.setState({
						loadingFilter: false,
						// closeNav: false, // uncomment to have it open and close on each filter
						mapLoading: false,
					});
				}, 300);
			});
		});
	};

	/////////////////////////////////////////////////////////////////////////////////////
	// DISTRICT EXPERIENCE - FUNCTION WHEN U.S. STATE or DISTRICT DROPDOWN ITEM SELECTED
	/////////////////////////////////////////////////////////////////////////////////////
	chooseDropdownItem = async (prop) => {
		
		//console.log('chooseDropdownItem', prop);
		if (!prop) {
			return;
		}

		this.setState({
			loadingFilter: true,
			// closeNav: true,  // uncomment to have it open and close on each filter
		}, async () => {

			const dropdownFilter = prop.split(':')[0];
			const value = prop.split(':')[1];
			const zoomLevel = prop.split(':')[2];
			// console.log(dropdownFilter);


			const abrv = value.split('.')[0];
			let itemNumber = value.split('.')[0];
			let itemValue = value.split('.')[1];
			let filterType = 'region';

			// empty filter type if user selected All States from drop down
			itemNumber === 'US' && (filterType = '');

			/////////////////////////////////////////////////////////////////////////////////////
			// USER SELECTED A STATE FROM THE STATE DROPDOWN
			/////////////////////////////////////////////////////////////////////////////////////
			if (dropdownFilter === 'state') {

				fireTag('C2',(prop.split('.')[1].toLowerCase()))

				// console.log('***** ', { value });

				// if (false) {
				if (value === 'US.All States') {
					this.resetMap(true).then(() => {
						// Don't know of a use case where we are not already on the map page so no need to route there
						/* this.routeToMap(); */
					});
				}
				else {
					// eslint-disable-next-line prefer-const
					let { selected, searchType } = this.state.congress;
					const { categoryId, categoryName, abrvState } = selected;
					const { input, currentSearch, currentRequest, invalidZip } = this.state.results;

					const FoundState = US_STATES_BOUNDS.find(usState => usState.state === itemValue);

					const { coordinates } = FoundState;

					const districtFilter = (data) => {

						const filterDropdownState = data.features.filter(district => district.state === abrv);
						// console.log({ dropdownFilter, selected });

						// districtUIData is a state filtered ARRAY
						// districtEach is an object of each district number and its dropdown display
						let districtUIData = [], districtEach = {};

						filterDropdownState.forEach(district => {
							districtEach = {};
							districtEach.numeral = Number(district.district_num);
							districtEach.display = district.alt_district_val;
							districtEach.zoom = district.zoom;
							districtUIData.push(districtEach);
						});

						if (itemNumber === abrvState) { // user selected SAME US State, so perform a de-selection
							itemNumber = 'US';
							itemValue = 'State';
							filterType = '';
							districtUIData = []; // clear out districts
						}

						// have to sort the district data since JSON dose not retain SQL sorted results
						districtUIData.sort((a, b) => (a.numeral > b.numeral) ? 1 : -1);

						// add 'All Districts' item to beginning of district data array
						if (districtUIData.length > 1) { // only add 'All Districts' when more than 1 district in State.
							districtEach = {};
							districtEach.numeral = 'US';
							districtEach.display = 'All Districts';
							districtEach.zoom = 4;
							districtUIData.unshift(districtEach); // add to beginning of array
						}

						const fetchCatId = (categoryId === '') ? 'all' : categoryId;
						const fetchState = (itemNumber === 'US') ? 'all' : itemNumber;

						if (invalidZip === true) {
							// invalid zip was in previous text search, so clear that when user selects new U.S. state
							searchType = '';
						}

						this.filterOrgs(fetchCatId, fetchState, 'all', searchType).then(async results => {

							// set URL query param to proper U.S. state
							let newQs = this.updateQueryStringParameter(
								this.state.search.results.queryString || '',
								'state',
								(itemNumber === 'US' ? '' : itemNumber.toLowerCase()),
							);

							// clear URL query param for district since we changed U.S. state
							newQs = this.updateQueryStringParameter(
								newQs || '',
								'district',
								'',
							);

							if (searchType !== 'keyword') {
								// if a geographical search was done, and user selected a state from drop down, clear the input field.
								this.setElem('search-input', '');
								// also remove URL param search= since it contains a state and we added state= to URL
								newQs = this.updateQueryStringParameter(
									newQs || '',
									'search',
									'',
								);
							}

							this.setState((prevState) => ({
								search: {
									...prevState.search,
									results: {
										queryString: newQs,
									},
								},
								results: {
									...prevState.results,
									resultsPos: 0,
									filterType,
									currentRequest: input.place_type === 'region' || invalidZip ? '' : currentRequest,
									currentSearch: input.place_type === 'region' || invalidZip ? '' : currentSearch,
								},
								congress: {
									...prevState.congress,
									currentNav: 'list',
									filter: 'state',
									filterDistrict: {
										...prevState.congress.filterDistrict,
										state: false,
									},
									districts: districtUIData,
									state: true,
									mapbox: {
										zoom: coordinates.zoom,
										pitch: coordinates.pitch,
										rotation: coordinates.rotation,
										center: coordinates.center,
										districts: {},
									},
									orgs: results.search,
									selected: {
										...prevState.congress.selected,
										districtName: 'District',
										abrvState: itemNumber,
										district: 'US',
										category: categoryName,
										categoryName,
										categoryId: fetchCatId,
										stateName: (itemValue === 'All States' ? 'State' : itemValue),
									},
									organizations: {
										...prevState.congress.organizations,
										byState: results.state,
										byDistrict: [],
									},
									searchType: searchType !== 'keyword' ? '' : searchType,
								},
							}));

							await this.routeToMap();

							this.setState({
								loadingFilter: false,
							},
								() => {
									setTimeout(() => {
										this.setState({
											// closeNav: false,
										});
									}, 1000);
								});
						});
					};

					fetch(`${process.env.PUBLIC_URL}/api/congress.php`)
						.then(data => data.json())
						.then(data => districtFilter(data));


				}

			}
			// ///////////////////////////////////////////////////////////////////////////////////
			// USER SELECTED A DISTRICT FROM THE DISTRICT DROPDOWN
			// ///////////////////////////////////////////////////////////////////////////////////
			else if (dropdownFilter === 'district') {

				fireTag('C3',(prop.split('.')[1].split(':')[0].toLowerCase()))

				const { selected, searchType } = this.state.congress;
				const { categoryId, abrvState, district } = selected;

				let filterType = 'region';

				if (itemNumber === district || itemNumber === 'US') { // user selected same District, so perform a de-selection
					itemNumber = 'US';
					itemValue = 'District';
					filterType = '';
				}

				const fetchCatId = (categoryId === '') ? 'all' : categoryId;
				const fetchState = (abrvState === 'US') ? 'all' : abrvState;
				const fetchDistrict = (abrvState === 'US' || itemNumber === 'US') ? 'all' : abrvState + itemNumber;

				await this.filterOrgs(fetchCatId, fetchState, fetchDistrict, searchType).then(async results => {

					const newQs = this.updateQueryStringParameter(
						this.state.search.results.queryString || '',
						'district',
						(itemNumber === 'US' ? '' : itemNumber),
					);


					this.setState((prevState) => ({
						search: {
							...prevState.search,
							results: {
								queryString: newQs,
								filterType,
							},
						},
						congress: {
							...prevState.congress,
							currentNav: 'list',
							filter: 'district',
							selected: {
								...prevState.congress.selected,
								districtName: itemValue,
								district: itemNumber,
							},
							filterDistrict: {
								...prevState.congress.filterDistrict,
								congressDistrict: false,
							},
							orgs: results.search,
							mapbox: {
								zoom: zoomLevel,
							},
							organizations: {
								...prevState.congress.organizations,
								byDistrict: results.dist,
							},

						},
						results: {
							...prevState.results,
							resultsPos: 0,
						},
					}));

					await this.routeToMap();

					this.setState({
						loadingFilter: false,
					},
						() => {
							setTimeout(() => {
								this.setState({
									// closeNav: false,  // uncomment to have it open and close on each filter
								});
							}, 1000);
						});

				});

			}

			this.ResultsBacktoTop();

		});

	};

	/////////////////////////////////////////////////////////////////////////////////////
	// DISTRICT Function that filters LEFT RAIL results based upon criteria
	/////////////////////////////////////////////////////////////////////////////////////
	filterOrgs = async (searchCategoryId, searchState, searchDistrict, searchType) => {

		const { all, byDistrict, byState, bySearch } = this.state.congress.organizations;
		const { input } = this.state.results;
		const searchStateUpper = searchState.toUpperCase();
		const searchDistrictUpper = searchDistrict.toUpperCase();

		const { abrvState: currentState, district: currentDistrictNum } = this.state.congress.selected;
		const currentDistrict = currentState + currentDistrictNum;

		let orgsToUse;
		// console.log('filterOrgs', input);
		if (searchType === 'keyword') {
			if (searchStateUpper === 'ALL' && searchCategoryId === 'all') {
				// user did a keyword search, and NO states NOR categories were selected, so use all orgs;
				if (bySearch.length || input.validLocation === false || (input.validLocation === true && bySearch.length === 0)) {
					// if there was a previous search, this accounts for the de-selection of state or category
					// this also accounts for invalid zip codes since they don't have search results
					// and finally accounts for valid location searches that have zero search results
					// if all these conditions are met, still use searched results
					orgsToUse = bySearch;
				}
				else {
					// was no previous search, and no state or category selected so search all orgs.
					orgsToUse = all;
				}
			}
			else {
				// user must have selected a U.S. state or category after doing a keyword search, so only filter on searched results
				orgsToUse = bySearch;
			}
		}
		else if (searchType === 'region' || searchType === 'place' || searchType === 'postcode') {
			// user previously did a U.S. state, or city, or zip search from the input field
			if (searchStateUpper !== 'ALL') {
				// U.S. state was selected from dropdown, so filter against all orgs
				orgsToUse = all;
			}
			else {
				// state was not selected from dropdown, but could have selected a category or district
				orgsToUse = bySearch;
			}
		}
		else {
			// searchType must have been empty
			// so use all orgs when filtering
			orgsToUse = all;
		}
		if (searchCategoryId !== 'all' && searchType !== 'keyword' && orgsToUse === bySearch) {
			// ONLY location based search results (bySearch) from Mapbox APIs have category_id as numerals.
			// our search results from DB (all) has category_id as string.
			// so need to convert category ID string (user selection in category right rail)
			// to a number for filtering to work with location based results
			searchCategoryId = +searchCategoryId;
		}

		const results = {
			state: null,
			dist: null,
			search: null,
		};

		const filterState = async (orgsToUse) => {

			const stateOrgs = (searchStateUpper === 'ALL')
				? orgsToUse
				: (searchStateUpper === currentState && byState.length > 0 && searchType !== 'keyword')
					? byState// .filter(org => org.properties.state === searchStateUpper)
					: orgsToUse.filter(org => org.properties.state === searchStateUpper);

			results.state = stateOrgs;
			return stateOrgs;
		};

		const filterDistrict = async (orgs) => {

			const distOrgs = (searchDistrictUpper === 'ALL')
				? orgs
				: (searchDistrictUpper === currentDistrict && byDistrict.length > 0 && searchType !== 'keyword')
					? byDistrict
					: orgs.filter(org => org.properties.congress_district === searchDistrictUpper);

			results.dist = distOrgs;
			return distOrgs;
		};


		const filterCategory = async (orgs) => {
			const catOrgs = (searchCategoryId === 'all')
				? orgs
				: orgs.filter(org => org.properties.category_id === searchCategoryId);

			results.search = catOrgs;
			return catOrgs;
		};

		return (searchCategoryId === 'all' && searchStateUpper === 'ALL' && searchDistrictUpper === 'ALL' && searchType === '')
			? {
				state: [],
				dist: [],
				search: this.state.results.all,
			}
			// eslint-disable-next-line no-return-await
			: await filterState(orgsToUse)
				.then((orgs) => filterDistrict(orgs)
					.then((orgs) => filterCategory(orgs).then(() => results)),
				);
	};

	Recenter = (location) => {

		// console.log('Recenter Location', location);
	};


	ResultsBacktoTop = () => {
		// left rail results
		if (window.location.pathname.indexOf('/map') > -1 || window.location.pathname.indexOf('/district') > -1) {
			const leftRail = document.getElementsByClassName('organizations__results-list')[0];
			// scroll left rail to top on text searches (if not already there)
			leftRail.scrollTop > 0 && (leftRail.scrollTop = 0);
		}
	};


	render() {
		const {
			appData,
			featured,
			home,
			results,
			isMobile,
			hoveredId,
			hoveredLayer,
			search,
			sustainability

		} = this.state;
		const { isEs } = this.props;
		const { location } = this.props;
		const { resultsPos } = results;


		// console.log('page ', page);

		// console.log(window.location.origin + '/impact');
		// console.log(process.env.PUBLIC_URL);



		// console.log(window.location.origin + '/impact');
		// console.log(process.env.PUBLIC_URL);

		typeof window.OneTrust !== 'undefined' && window.OneTrust.initializeCookiePolicyHtml();

		return (
			<>
				<Switch>
					<Route // HOME PAGE
						exact
						path="/"
						render={(routeProps) => (
							<Home
								{...routeProps}
								activePage="home"
								location={location}
								uiState={home}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // HOUSING PAGE
						exact
						path="/housing/"
					>
							<Redirect
							to={{
								pathname: '/',
								search: location.search,
							}} />
					</Route>
					<Route // HOUSING PAGE
						path="/es/impact/housing/"
					>
						<Redirect
						to={{
							pathname: '/',
							search: location.search,
						}} />
					</Route>
					<Route // HOUSING PAGE
						path="/en/impact/housing/"
					>
						<Redirect
						to={{
							pathname: '/',
							search: location.search,
						}} />
					</Route>
					<Route // SUSTAINABILITY PAGE
						exact
						path="/sustainability/"
						render={(routeProps) => (
							<Sustainability
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								addVideoClickListeners={this.addVideoClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
								displayVideoOverlay={this.displayVideoOverlay}
							/>
						)}
					/>
					<Route // CONGRESSIONAL DISTRICT MAP PAGE - DEEP LINKED VIA QUERY PARAMS
						path="/map/:query"
						render={routeProps => (
							<Congress
								{...routeProps}
								{...{ resultsPos }}
								congress={this.state.congress}
								toggleCongressDropdowns={this.toggleCongressDropdowns}
								chooseDropdownItem={this.chooseDropdownItem}
								chooseDropdownType={this.chooseDropdownType}
								isMobile={isMobile}
								uiState={results}
								handleEvent={this.handleEvent}
								orgs={this.state.congress.orgs}
								all={this.state.congress.organizations.all}
								resetMap={this.resetMap}
								loadingFilter={this.state.loadingFilter}
								closeNav={this.state.closeNav}
								onRef={districtMapMethods => {
									this.districtMapMethods = districtMapMethods
								}}
								dropDownCongress={this.dropDownCongress}
								mapCenter={this.state.mapCenter}
								location={location}
								hoveredId={hoveredId}
								hoveredLayer={hoveredLayer}
								mapLoading={this.state.mapLoading}
								textSearchedOrgs={this.state.congress.organizations.bySearch}
								checkForCityOrZip={this.checkForCityOrZip}
								addExitClickListeners={this.addExitClickListeners}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // DEFAULT MAP PAGE
						exact
						path="/map"
						render={routeProps => (
							<Congress
								{...routeProps}
								{...{ resultsPos }}
								congress={this.state.congress}
								toggleCongressDropdowns={this.toggleCongressDropdowns}
								chooseDropdownItem={this.chooseDropdownItem}
								chooseDropdownType={this.chooseDropdownType}
								isMobile={isMobile}
								uiState={results}
								handleEvent={this.handleEvent}
								orgs={this.state.congress.orgs}
								all={this.state.congress.organizations.all}
								resetMap={this.resetMap}
								loadingFilter={this.state.loadingFilter}
								closeNav={this.state.closeNav}
								onRef={districtMapMethods => {
									this.districtMapMethods = districtMapMethods
								}}
								dropDownCongress={this.dropDownCongress}
								mapCenter={this.state.mapCenter}
								location={location}
								hoveredId={hoveredId}
								hoveredLayer={hoveredLayer}
								mapLoading={this.state.mapLoading}
								textSearchedOrgs={this.state.congress.organizations.bySearch}
								checkForCityOrZip={this.checkForCityOrZip}
								addExitClickListeners={this.addExitClickListeners}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // CONGRESSIONAL DISTRICT MAP
						exact
						path="/district"
					>
						<Redirect
							to={{
								pathname: '/map/',
								search: location.search,
							}} />
					</Route>
					<Route // ORGANIZATION DETAIL PAGE
						exact
						path="/organization/"
						render={routeProps => (
							<Organization
								{...routeProps}
								location={location}
								uiState={featured}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								stateShowFilter={this.state.results.showFilter}
								appData={appData}
								search={search.organizations}
								parseQueryString={this.parseQueryString}
								handleFilterClick={(community) => this.handleEvent({
									action: 'search',
									type: 'community',
									name: community,
									toggleable: false,
									origin: 'organization',
								})}
								chooseDropdownType={this.chooseDropdownType}
								mapLoading={this.state.mapLoading}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								addExitClickListeners={this.addExitClickListeners}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // MAYORS PAGE
						exact
						path="/sustainability/wells-fargo-joins-us-mayors-to-support-cities-weathering-climate-change/"
						render={(routeProps) => (
							<Mayors
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // GOALS PAGE
						exact
						path="/sustainability/wells-fargo-sets-expanded-operational-goals/"
						render={(routeProps) => (
							<Goals
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // EV PAGE
						exact
						path="/sustainability/electric-vehicles-veer-into-the-fast-lane/"
						render={(routeProps) => (
							<EV
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // URBAN FORESTS PAGE
						exact
						path="/sustainability/urban-forests-are-great-for-people-and-the-planet/"
						render={(routeProps) => (
							<UrbanForests
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // COMMUNITY SOLAR PAGE
						exact
						path="/sustainability/future-of-community-accessible-solar-projects/"
						render={(routeProps) => (
							<Solar
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // GREEN BONDS PAGE
						exact
						path="/sustainability/economic-advantage-of-issuing-green-bonds/"
						render={(routeProps) => (
							<Bonds
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					{
						/*
					<Route // TRENDS PAGE
						exact
						path="/sustainability/sustainability-trends-for-2024/"
						render={(routeProps) => (
							<Trends
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
						*/
					}
					<Route // SHIFT TO EV PAGE
						exact
						path="/sustainability/making-the-shift-to-evs-is-getting-more-affordable/"
						render={(routeProps) => (
							<Shift
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // ENGAGING EMPLOYEES ON SUSTAINABILITY PAGE
						exact
						path="/sustainability/engaging-employees-on-sustainability/"
						render={(routeProps) => (
							<Engaging
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // Building a pipeline of sustainable affordable housing PAGE
						exact
						path="/sustainability/building-a-pipeline-of-sustainable-affordable-housing/"
						render={(routeProps) => (
							<Pipeline
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // Developing financial structures to propel clean energy PAGE
						exact
						path="/sustainability/developing-financial-structures-to-propel-clean-energy"
						render={(routeProps) => (
							<Propel
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // Three transformative renewable energy transactions PAGE
						exact
						path="/sustainability/three-transformative-renewable-energy-transactions/"
						render={(routeProps) => (
							<Transformative
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					<Route // From an industrial past to a sustainable future PAGE
						exact
						path="/sustainability/from-an-industrial-past-to-a-sustainable-future/"
						render={(routeProps) => (
							<PastFuture
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // Two years of EV investments spark key economic impacts
						exact
						path="/sustainability/two-years-of-ev-investments-spark-key-economic-impacts/"
						render={(routeProps) => (
							<EVInvestment
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // Sustainability bonds brighten city streets
						exact
						path="/sustainability/sustainability-bonds-brighten-city-streets/"
						render={(routeProps) => (
							<BrightenCity
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // Nuclear energy is back in the spotlight
						exact
						path="/sustainability/nuclear-energy-is-back-in-the-spotlight/"
						render={(routeProps) => (
							<NuclearEnergy
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>

					<Route // 2025 Trends Page
						exact
						path="/sustainability/top-sustainability-trends-for-2025/"
						render={(routeProps) => (
							<SustainabilityTrends
								{...routeProps}
								location={location}
								uiState={sustainability}
								isMobile={isMobile}
								handleEvent={this.handleEvent}
								chooseDropdownType={this.chooseDropdownType}
								appData={appData}
								mapLoading={this.state.mapLoading}
								alreadyShown={this.state.alreadyShown}
								results={results}
								checkForCityOrZip={this.checkForCityOrZip}
								goToAnchor={this.goToAnchor}
								addExitClickListeners={this.addExitClickListeners}
								resetMap={this.resetMap}
								closeExitOverlay={this.closeExitOverlay}
								displayModalOverlay={this.displayModalOverlay}
								modalOverlay={this.state.modalOverlay}
							/>
						)}
					/>
					

				</Switch>
			</>
		);
	}
}

export default withRouter(App);
